import { useMutation } from "@tanstack/react-query";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import Cookies from "js-cookie";
import AuthAPI from "../../api/AuthAPI";

interface LoginProps {
  email: string;
  password: string;
  onSuccess?: () => any;
}

const useLogin = () => {
  const login = useMutation({
    mutationFn: ({ email, password }: LoginProps) =>
      AuthAPI.authenticateLocal(email, password).then((data) => {
        const { authenticationToken, user } = data.data.data;

        // Save authToken to Cookie
        Cookies.set("authenticationToken", authenticationToken, {
          expires: 7,
          sameSite: "strict",
          secure: window.location.origin.startsWith("https"),
        });

        const urlParams = new URLSearchParams(window.location.search);
        const redirect = urlParams.get("r");

        if (redirect) {
          return window.open(redirect, "_self");
        }

        let tenantID =
          sessionStorage.getItem("LastVisitedTenant") ??
          user?.LastVisitedTenant;
        let redirectURL = "/clouds";

        if (!tenantID) {
          tenantID = user?.Tenants?.[0]?.TenantID;
        }

        if (tenantID) {
          redirectURL = `/clouds/${tenantID}/activity`;
        }

        // TODO: Fix this workaround.. but is very challenging - UserContext, CRMLayout involved
        window.location.href = redirectURL;
      }),
  });

  return {
    login: login.mutate,
    loginLoading: login.isPending,
    loginError: login.error ? getErrorMessage(login.error) : null,
  };
};

export default useLogin;
